import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { syncMiniProgramNavBar } from "./miniProgramNavBarSync";
import { resolveLfPageTitle } from "./pageTitle";
import { applyPageShellBg, resolveShellBgFromPathname } from "./pageShellBg";

/** App 级：每次 pathname 变化立即刷 body 背景与固定两档 document.title */
export function useRouteShellBgSync(): void {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const { bg, front } = resolveShellBgFromPathname(pathname);
    applyPageShellBg({ bg, front, title: resolveLfPageTitle(pathname) });
    syncMiniProgramNavBar(pathname);
  }, [pathname]);
}
